var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.830078,
    width: 40.4286,
    height: 39,
    rx: 5.5,
    fill: "#FFF8F5",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M20.5 23.9961V27.1211",
    stroke: "#FF8047",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M26.7507 29.2051H22.584",
    stroke: "#FF8047",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M18.4167 29.2051H14.25",
    stroke: "#FF8047",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7923 15.9766V20.3516C27.7923 23.2682 27.0632 23.9974 24.1465 23.9974H16.8548C13.9382 23.9974 13.209 23.2682 13.209 20.3516V13.0599C13.209 10.1432 13.9382 9.41406 16.8548 9.41406H17.9486C19.0423 9.41406 19.2819 9.73694 19.6985 10.289L20.7923 11.7474C21.0736 12.112 21.2298 12.3308 21.959 12.3308H24.1465C27.0632 12.3308 27.7923 13.0599 27.7923 15.9766Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4993 31.2878C21.6499 31.2878 22.5827 30.355 22.5827 29.2044C22.5827 28.0538 21.6499 27.1211 20.4993 27.1211C19.3488 27.1211 18.416 28.0538 18.416 29.2044C18.416 30.355 19.3488 31.2878 20.4993 31.2878Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon5);
export default __webpack_public_path__ + "static/media/feature-icon-5.c6030bf530b00fcbd69a52d83b09b7c4.svg";
export { ForwardRef as ReactComponent };